// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"362":"brand","365":"culture","443":"about","697":"news"}[chunkId] + "." + {"362":"02abb70b","365":"c9b0b153","443":"0faf2ea3","697":"4943ad36"}[chunkId] + ".css";
};